export const AUTH0_LOGIN_REQUIRED_ERROR = 'login_required';
